import React from "react";
import { PlayGameMeta } from "../core";

export interface PlayGameCardProps {
  game: PlayGameMeta;
  onPlay?: () => void;
}

const difficultyLabelMap: Record<PlayGameMeta["difficulty"], string> = {
  easy: "facile",
  medium: "intermédiaire",
  hard: "difficile",
};

const categoryLabelMap: Record<PlayGameMeta["category"], string> = {
  memory: "mémoire",
  logic: "logique",
  attention: "attention",
  speed: "vitesse",
  creativity: "créativité",
  flexibility: "flexibilité",
};

export const PlayGameCard: React.FC<PlayGameCardProps> = ({ game, onPlay }) => {
  return (
    <div className="mm-surface p-4 space-y-2">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold">{game.title}</h3>
        <span className="text-[11px] px-2 py-0.5 rounded-full border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
          {difficultyLabelMap[game.difficulty]}
        </span>
      </div>
      <p className="text-sm text-slate-600 dark:text-slate-300">{game.description}</p>
      <div className="flex gap-2 text-xs text-slate-500 dark:text-slate-400 flex-wrap">
        <span>Catégorie : {categoryLabelMap[game.category]}</span>
        {game.estimatedDurationMinutes && <span>{game.estimatedDurationMinutes} min</span>}
      </div>
      <button
        type="button"
        onClick={onPlay}
        className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
      >
        Jouer
      </button>
    </div>
  );
};
